import { DEFAULT_PRODUCT_SOURCE, isValidSource } from '@/config/products'
import { getStoredSource, setStoredSource } from '@/config/sourceStorage'

export const resolveSource = querySource => {
  if (isValidSource(querySource)) {
    setStoredSource(querySource)
    return querySource
  }

  const stored = getStoredSource()
  if (isValidSource(stored)) {
    return stored
  }

  setStoredSource(DEFAULT_PRODUCT_SOURCE)
  return DEFAULT_PRODUCT_SOURCE
}
